var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPreviousAppointment)?_c('button',{staticClass:"button",class:_vm.loading && 'is-loading',on:{"click":function($event){$event.stopPropagation();return _vm.onRebook()}}},[_vm._m(0),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-refresh"})])
}]

export { render, staticRenderFns }